<template>
    <div class="animated fadeIn master-form-page">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div class="master-back-wrapper" v-show="!isModal">
                <b-button type="button" name="anggotaBackBtn" @click="$router.go(-1)">
                    <i class="fa fa-angle-left mr-2"></i>Back
                </b-button>
            </div>
            <div class="master-form-card">
            <h5 class="master-page-title" v-show="!isModal">Input Anggota</h5>
            <b-form @submit.prevent="openModalConfirm">
                <DataIdentitas :dataIdentitas="input.dataIdentitas" :dataJenisIdentitas="jenisIdentitas" @reset="resetDataIdentitas" />
                <DataAnggota :dataAnggota="input.dataAnggota" @reset="resetDataAnggota" @copy="copyDataIdentitas" />
                <DataKerabat :dataKerabat="input.dataKerabat" :dataRequired="requiredForDataKerabatAndPihakLain" @reset="resetDataKerabat" />
                <DataPihakLain :dataPihakLain="input.dataPihakLain" :dataRequired="requiredForDataKerabatAndPihakLain" @reset="resetDataPihakLain" />
                <DataFoto :dataFoto="input.dataFoto" />
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="anggotaSubmitBtn" variant="pgiBtn">Simpan</b-button>
                    <b-button type="button" name="anggotaCancelBtn" @click="$router.go(-1)">Batal</b-button>
                </div>
            </b-form>
            </div>
        </div>
        <ModalConfirm id="modal-confirm-copy" title="Confirm Copy Data Identitas ke Anggota" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengisi bagian Anggota dengan data dari Identitas?" @submit="onCopyFields" />
        <ModalConfirm id="modal-confirm-reset" title="Confirm Reset Kotak Input" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menghapus semua kotak input bagian ini?" @submit="onResetFields" />
        <ModalConfirm id="modal-confirm-input" title="Confirm Input Anggota" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput anggota ini?" @submit="onSubmit" />
    </div>
</template>

<script>

import DataAnggota from '../../../components/anggota/DataAnggota';
import DataIdentitas from '../../../components/anggota/DataIdentitas';
import DataKerabat from '../../../components/anggota/DataKerabat';
import DataPihakLain from '../../../components/anggota/DataPihakLain';
import DataFoto from '../../../components/anggota/DataFoto';

export default {
    name: 'input-anggota',
    components: {
        DataAnggota,
        DataIdentitas,
        DataKerabat,
        DataPihakLain,
        DataFoto
    },
    data(){
        return{
            initStatus: 0,
            isSubmitting: false,
            input:{
                dataIdentitas: {
                    nama: '',
                    jenisIdentitas: null,
                    noIdentitas: '',
                    kotaLahir: '',
                    tanggalLahir: '',
                    kotaKtp: '',
                    kecamatanKtp: null,
                    kelurahanDesaKtp: null, 
                    rtKtp: '',
                    rwKtp: '',
                    alamatKtp: '',
                    listKecamatan: [],
                    listKelurahan: [],
                    kecLoading: false,
                    kelLoading: false
                },
                dataAnggota: {
                    pekerjaan: '',
                    teleponRumahSekarang: '',
                    noHandphoneSekarang: '',
                    teleponKantorSekarang: '',
                    kotaSekarang: '',
                    kecamatanSekarang: null,
                    kelurahanDesaSekarang: null,
                    rtSekarang: '',
                    rwSekarang: '',
                    alamatSekarang: '',
                    listKecamatan: [],
                    listKelurahan: [],
                    kecLoading: false,
                    kelLoading: false
                },
                dataKerabat: {
                    namaSuamiAtauIstri: '',
                    namaAyah: '',
                    namaIbu: '',
                },
                dataPihakLain: {
                    namaPihakLain: '',
                    hubunganPihakLain: '',
                    teleponRumahPihakLain: '',
                    noHandphonePihakLain: '',
                    teleponKantorPihakLain: '',
                    kotaPihakLain: '',
                    kecamatanPihakLain: null,
                    kelurahanDesaPihakLain: null,
                    rtPihakLain: '',
                    rwPihakLain: '',
                    alamatPihakLain: '',
                    listKecamatan: [],
                    listKelurahan: [],
                    kecLoading: false,
                    kelLoading: false
                },
                dataFoto: {
                    fotoIdentitas: null,
                    fotoIdentitasBase64: null,
                    activeFotoIdentitasBase64: null,
                    fotoPendukung1: null,
                    fotoPendukung1Base64: null,
                    activeFotoPendukung1Base64: null,
                    fotoPendukung2: null,
                    fotoPendukung2Base64: null,
                    activeFotoPendukung2Base64: null,
                    fotoPendukung3: null,
                    fotoPendukung3Base64: null,
                    activeFotoPendukung3Base64: null,
                } 
            },
            jenisIdentitas: [],
            resetSection: null
        }
    },
    props: {
        isModal: { type: Boolean, default: false},
        requiredForDataKerabatAndPihakLain: { type: Boolean, default: false}
    },

    methods: {

        //----------------- Fungsi Inisialisasi -----------------
        
        init(){
            this.initStatus = 0

            let getJenisIdentitas = this.$axios.get("nasabah/jenis-identitas").then(response => {

                this.jenisIdentitas = response.data.map(item => {
                    return { value: item.id, text: item.name }
                })

            })

            Promise.all([getJenisIdentitas]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()

            //----------------- Append Data KTP -----------------
            
            payload.append("cabangId", localStorage.getItem("activeCabangId"))

            payload.append('nama', this.input.dataIdentitas.nama)
            payload.append('jenisIdentitasId', this.input.dataIdentitas.jenisIdentitas)
            payload.append('noIdentitas', this.input.dataIdentitas.noIdentitas)
            payload.append('alamatKtp', this.input.dataIdentitas.alamatKtp)
            payload.append('kelurahanDesaKtp', this.input.dataIdentitas.kelurahanDesaKtp)
            payload.append('rtKtp', this.input.dataIdentitas.rtKtp)
            payload.append('rwKtp', this.input.dataIdentitas.rwKtp)
            

            //----------------- Append Data Anggota Sekarang -----------------

            payload.append('alamatSekarang', this.input.dataAnggota.alamatSekarang)
            payload.append('kelurahanDesaSekarang', this.input.dataAnggota.kelurahanDesaSekarang)
            payload.append('rtSekarang', this.input.dataAnggota.rtSekarang)
            payload.append('rwSekarang', this.input.dataAnggota.rwSekarang)
            payload.append('kotaLahir', this.input.dataIdentitas.kotaLahir.id)
            payload.append('tanggalLahir', this.input.dataIdentitas.tanggalLahir)
            payload.append('teleponRumahSekarang', this.input.dataAnggota.teleponRumahSekarang)
            payload.append('noHandphoneSekarang', this.input.dataAnggota.noHandphoneSekarang)
            payload.append('teleponKantorSekarang', this.input.dataAnggota.teleponKantorSekarang)
            payload.append('pekerjaan', this.input.dataAnggota.pekerjaan)


            //----------------- Append Data Kerabat -----------------

            if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.namaSuamiAtauIstri)) payload.append('namaSuamiAtauIstri', this.input.dataKerabat.namaSuamiAtauIstri)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.namaAyah)) payload.append('namaAyah', this.input.dataKerabat.namaAyah)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.namaIbu)) payload.append('namaIbu', this.input.dataKerabat.namaIbu)


            //----------------- Append Data Pihak Lain -----------------

            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.namaPihakLain)) payload.append('namaPihakLain', this.input.dataPihakLain.namaPihakLain)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.hubunganPihakLain)) payload.append('hubunganPihakLain', this.input.dataPihakLain.hubunganPihakLain)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.alamatPihakLain)) payload.append('alamatPihakLain', this.input.dataPihakLain.alamatPihakLain)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.kelurahanDesaPihakLain)) payload.append('kelurahanDesaPihakLain', this.input.dataPihakLain.kelurahanDesaPihakLain)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.rtPihakLain)) payload.append('rtPihakLain', this.input.dataPihakLain.rtPihakLain)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.rwPihakLain)) payload.append('rwPihakLain', this.input.dataPihakLain.rwPihakLain)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.teleponRumahPihakLain)) payload.append('teleponRumahPihakLain', this.input.dataPihakLain.teleponRumahPihakLain)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.noHandphonePihakLain)) payload.append('noHandphonePihakLain', this.input.dataPihakLain.noHandphonePihakLain)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.teleponKantorPihakLain)) payload.append('teleponKantorPihakLain', this.input.dataPihakLain.teleponKantorPihakLain)


            //----------------- Append Data Foto -----------------
            if(this.input.dataFoto.activeFotoIdentitasBase64 != null)
                payload.append('fotoIdentitas', this.input.dataFoto.activeFotoIdentitasBase64)
            
            if(this.input.dataFoto.activeFotoPendukung1Base64 != null)
                payload.append('fotoPendukung1', this.input.dataFoto.activeFotoPendukung1Base64)
            
            if(this.input.dataFoto.activeFotoPendukung2Base64 != null)
                payload.append('fotoPendukung2', this.input.dataFoto.activeFotoPendukung2Base64)
            
            if(this.input.dataFoto.activeFotoPendukung3Base64 != null)
                payload.append('fotoPendukung3', this.input.dataFoto.activeFotoPendukung3Base64)
                
            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post('nasabah/', payload, { timeout: 300000 }).then(response => {
                if(this.isModal == true){
                    this.$helper.toastSucc(this, "Anggota nasabah baru telah berhasil dibuat!")
                    let dataModalAnggota = {
                        idAnggota: response.data.id,
                        noAnggota : response.data.noAnggota,
                        noIdentitas: this.input.dataIdentitas.noIdentitas,
                        jenisIdentitas: response.data.jenisIdentitas,
                        nama: response.data.name,
                        noHp: this.input.dataAnggota.noHandphoneSekarang,
                        noRumah: this.input.dataAnggota.teleponRumahSekarang,
                        alamat: this.input.dataAnggota.alamatSekarang,
                        isComplete: response.data.isComplete
                    }
                    this.$emit("submitModalAnggota", dataModalAnggota)
                }else{
                    this.$helper.setFlash(`Anggota nasabah baru telah berhasil dibuat!`)
                    let path = this.$route.path.split('/')
                    path.pop()
                    path = path.join("/") + `/${response.data.id}`
                    this.$router.push({ path })
                }
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },
        

        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.dataIdentitas.kotaLahir)){
                this.$helper.toastErr(this, "Mohon isi tempat lahir terlebih dahulu!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.dataIdentitas.kelurahanDesaKtp)){
                this.$helper.toastErr(this, "Mohon isi alamat sesuai ktp dengan lengkap terlebih dahulu!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.dataAnggota.kelurahanDesaSekarang)){
                this.$helper.toastErr(this, "Mohon isi alamat domisili dengan lengkap terlebih dahulu!")
            }else if (this.input.dataFoto.fotoIdentitas == null && this.input.dataFoto.fotoIdentitasBase64 == null) {
                this.$helper.toastErr(this, "Tolong upload foto KTP anda")
            }else {
                this.$bvModal.show("modal-confirm-input")
            }
        },

        onResetFields(){
            if (this.resetSection == 0) {
                this.input.dataIdentitas = {
                    nama: '',
                    jenisIdentitas: null,
                    noIdentitas: '',
                    kotaLahir: '',
                    tanggalLahir: '',
                    kotaKtp: {},
                    kecamatanKtp: null,
                    kelurahanDesaKtp: null, 
                    rtKtp: '',
                    rwKtp: '',
                    alamatKtp: '',
                    listKecamatan: [],
                    listKelurahan: [],
                    kecLoading: false,
                    kelLoading: false
                }
            } 
            else if (this.resetSection == 1) {
                this.input.dataAnggota = {
                    pekerjaan: '',
                    teleponRumahSekarang: '',
                    noHandphoneSekarang: '',
                    teleponKantorSekarang: '',
                    kotaSekarang: {},
                    kecamatanSekarang: null,
                    kelurahanDesaSekarang: null,
                    rtSekarang: '',
                    rwSekarang: '',
                    alamatSekarang: '',
                    listKecamatan: [],
                    listKelurahan: [],
                    kecLoading: false,
                    kelLoading: false
                }
            }
            else if (this.resetSection == 2) {
                this.input.dataKerabat = {
                    namaSuamiAtauIstri: '',
                    namaAyah: '',
                    namaIbu: '',
                }
            }
            else if (this.resetSection == 3) {
                this.input.dataPihakLain = {
                    namaPihakLain: '',
                    hubunganPihakLain: '',
                    teleponRumahPihakLain: '',
                    noHandphonePihakLain: '',
                    teleponKantorPihakLain: '',
                    kotaPihakLain: {},
                    kecamatanPihakLain: null,
                    kelurahanDesaPihakLain: null,
                    rtPihakLain: '',
                    rwPihakLain: '',
                    alamatPihakLain: '',
                    listKecamatan: [],
                    listKelurahan: [],
                    kecLoading: false,
                    kelLoading: false
                   
                }
            }

            this.$bvModal.hide("modal-confirm-reset")
        },

        resetDataIdentitas(){
            this.resetSection = 0
            this.$bvModal.show("modal-confirm-reset")
        },

        resetDataAnggota(){
            this.resetSection = 1
            this.$bvModal.show("modal-confirm-reset")
        },

        resetDataKerabat(){
            this.resetSection = 2
            this.$bvModal.show("modal-confirm-reset")
        },

        resetDataPihakLain(){
            this.resetSection = 3
            this.$bvModal.show("modal-confirm-reset")
        },

        onCopyFields(){
            if (Object.keys(this.input.dataIdentitas.kotaKtp).length != 0) {
                this.input.dataAnggota.kotaSekarang = this.input.dataIdentitas.kotaKtp
                this.input.dataAnggota.kecLoading = true
                
                this.$axios.get(`area/kecamatan/${this.input.dataIdentitas.kotaKtp.id}`).then(response => {
                    this.input.dataAnggota.listKecamatan = response.data
                    this.input.dataAnggota.kecLoading = false
                    this.input.dataAnggota.kelLoading = true

                    if (this.input.dataIdentitas.kecamatanKtp != null) {
                        this.input.dataAnggota.kecamatanSekarang = this.input.dataIdentitas.kecamatanKtp
                        

                        this.$axios.get(`area/kelurahan/${this.input.dataIdentitas.kecamatanKtp}`).then(response => {
                            this.input.dataAnggota.listKelurahan = response.data
                            this.input.dataAnggota.kelLoading = false

                            if (this.input.dataIdentitas.kelurahanDesaKtp != null) {
                                this.input.dataAnggota.kelurahanDesaSekarang = this.input.dataIdentitas.kelurahanDesaKtp
                            }
                        })
                        .catch(error => {
                            console.log(error)
                            this.input.dataAnggota.kelLoading = false
                            this.input.dataAnggota.loadKelFail = true

                            console.log(error.response.data.reason)
                            this.$helper.parseError(this, error)
                        })
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.input.dataAnggota.kecLoading = false
                    this.input.dataAnggota.loadKecFail = true

                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }

            if (this.input.dataIdentitas.rtKtp != '') this.input.dataAnggota.rtSekarang= this.input.dataIdentitas.rtKtp
            if (this.input.dataIdentitas.rwKtp != '') this.input.dataAnggota.rwSekarang = this.input.dataIdentitas.rwKtp
            if (this.input.dataIdentitas.alamatKtp != '') this.input.dataAnggota.alamatSekarang = this.input.dataIdentitas.alamatKtp

            this.$bvModal.hide("modal-confirm-copy")
        },

        copyDataIdentitas(){
            this.$bvModal.show("modal-confirm-copy")
        }
    },

    watch: {

        //----------------- Pantau Data Identitas -----------------

        'input.dataIdentitas.kotaKtp': function(x){
            if (x.id != undefined){
                this.input.dataIdentitas.kecLoading = true
                this.input.dataIdentitas.kecamatanKtp = null
                this.input.dataIdentitas.listKecamatan = []
                this.input.dataIdentitas.kelurahanDesaKtp = null
                this.input.dataIdentitas.listKelurahan = []
                this.$axios.get(`area/kecamatan/${x.id}`).then(response => {
                    this.input.dataIdentitas.listKecamatan = response.data
                    this.input.dataIdentitas.kecLoading = false
                })
                .catch(error => {
                    console.log(error)
                    this.input.dataIdentitas.kecLoading = false
                    this.input.dataIdentitas.loadKecFail = true

                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }
        },

        'input.dataIdentitas.kecamatanKtp': function(id){
            if (id != null){
                this.input.dataIdentitas.kelLoading = true
                this.input.listKelurahan = []
                this.input.dataIdentitas.kelurahanDesaKtp = null
                this.$axios.get(`area/kelurahan/${id}`).then(response => {
                    this.input.dataIdentitas.listKelurahan = response.data
                    this.input.dataIdentitas.kelLoading = false
                })
                .catch(error => {
                    console.log(error)
                    this.input.dataIdentitas.kelLoading = false
                    this.input.dataIdentitas.loadKelFail = true
                    
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }
        },


        //----------------- Pantau Data Anggota Sekarang -----------------
        
        'input.dataAnggota.kotaSekarang': function(x){
            if (x.id != undefined){
                this.input.dataAnggota.kecLoading = true
                this.input.dataAnggota.kecamatanSekarang = null
                this.input.dataAnggota.listKecamatan = []
                this.input.dataAnggota.kelurahanDesaSekarang = null
                this.input.dataAnggota.listKelurahan = []
                this.$axios.get(`area/kecamatan/${x.id}`).then(response => {
                    this.input.dataAnggota.listKecamatan = response.data
                    this.input.dataAnggota.kecLoading = false
                })
                .catch(error => {
                    console.log(error)
                    this.input.dataAnggota.kecLoading = false
                    this.input.dataAnggota.loadKecFail = true

                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }
        },

        'input.dataAnggota.kecamatanSekarang': function(id){
            if (id != null){
                this.input.dataAnggota.kelLoading = true
                this.input.listKelurahan = []
                this.input.dataAnggota.kelurahanDesaSekarang = null
                this.$axios.get(`area/kelurahan/${id}`).then(response => {
                    this.input.dataAnggota.listKelurahan = response.data
                    this.input.dataAnggota.kelLoading = false
                })
                .catch(error => {
                    console.log(error)
                    this.input.dataAnggota.kelLoading = false
                    this.input.dataAnggota.loadKelFail = true

                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }
        },


        //----------------- Pantau Data Pihak Lain -----------------

        'input.dataPihakLain.kotaPihakLain': function(x){
            if (x.id != undefined){
                this.input.dataPihakLain.kecLoading = true
                this.input.dataPihakLain.kecamatanPihakLain = null
                this.input.dataPihakLain.listKecamatan = []
                this.input.dataPihakLain.kelurahanDesaPihakLain = null
                this.input.dataPihakLain.listKelurahan = []
                this.$axios.get(`area/kecamatan/${x.id}`).then(response => {
                    this.input.dataPihakLain.listKecamatan = response.data
                    this.input.dataPihakLain.kecLoading = false
                })
                .catch(error => {
                    console.log(error)
                    this.input.dataPihakLain.kecLoading = false
                    this.input.dataPihakLain.loadKecFail = true

                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }
        },

        'input.dataPihakLain.kecamatanPihakLain': function(id){
            if (id != null){
                this.input.dataPihakLain.kelLoading = true
                this.input.listKelurahan = []
                this.input.dataPihakLain.kelurahanDesaPihakLain = null
                this.$axios.get(`area/kelurahan/${id}`).then(response => {
                    this.input.dataPihakLain.listKelurahan = response.data
                    this.input.dataPihakLain.kelLoading = false
                })
                .catch(error => {
                    console.log(error)
                    this.input.dataPihakLain.kelLoading = false
                    this.input.dataPihakLain.loadKelFail = true

                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }
        }
    },

    created(){
        this.init()
    }
}
</script>
